import styled, { css } from 'styled-components';

import TextInput from '../TextInput';

export const StyledVisibilityButton = styled.button<{
  readOnly?: boolean;
}>`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  padding: 2px 12px 0 12px;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.primary};
  pointer-events: auto;
  cursor: pointer;
  outline: 0;
  border-radius: ${({ theme }) => theme?.Input?.borderRadius};

  ${({ disabled, readOnly }) => (disabled || readOnly) && css`
    opacity: .4;
    color: ${({ theme }) => theme.colors.gray5};
    cursor: text;
  `}

  ${({ disabled, readOnly }) => (!disabled && !readOnly) && css`
    ${TextInput.StyledInput}:focus + ${TextInput.StyledSign} & {
      color: ${({ theme }) => theme.colors.lighter};
    }

    &:hover{
      color: ${({ theme }) => theme.colors.lighter};
    }

    &:hover, ${TextInput.StyledInput}:focus + ${TextInput.StyledSign} &:hover {
      color: ${({ theme }) => theme.colors.lightest};
    }

    &:focus-visible, &:focus {
      box-shadow: ${({ theme }) => theme.boxShadows?.focus};
    }

    &:focus:not(&:focus-visible) {
      box-shadow: none;
    }

    &:active  {
      color: ${({ theme }) => theme.colors.lighter};
    }
  `}
`;
